<template>
<div>
    <Header />
    <div class="desktop">
        <BlackHeaderCenter :headerText="headerText" :subText="subText" :fadedText="fadedText" />
    </div>
    <div class="mobile">
        <BlackHeaderMobile :headerText="headerText" :subText="subText" :fadedText="fadedText" :isTextinput="false" />
    </div>
    <BodyLinks />
    <b-container class="mt-5">
        <Activation />
        <b-row align-h="center">
            <b-col class="text-center mb-5" md="6" cols="12">
                <div class="box box-green">
                    <span @click="openTeach" class="title mb-5">Teach</span>
                    <div class="mt-5"><img src="../../assets/images/educator.svg" alt=""></div>
                    <p class="sub-title mt-3">
                        Language Instructor
                    </p>
                </div>
            </b-col>
            <b-col class="text-center mb-5" md="6" cols="12">
                <div class="box box-peach">
                    <router-link to="/languages/events" class="title mb-5">Learn</router-link>
                    <div class="mt-5"> <img src="../../assets/images/student.svg" alt=""></div>
                    <p class="sub-title mt-3">
                        Language Student
                    </p>
                </div>
            </b-col>
        </b-row>
        <b-row align-h="center">
            <b-col class="text-center mb-5" md="6" cols="12">
                <div class="box box-lilac">
                    <span @click="openCreate" class="title mb-5">Create</span>
                    <div class="mt-5"> <img src="../../assets/images/create-club.svg" alt=""></div>
                    <p class="sub-title mt-3">
                        Language Club
                    </p>
                </div>

            </b-col>
            <b-col class="text-center mb-5" md="6" cols="12">
                <div class="box box-skye-blue">
                    <router-link to="/languages/clubs" class="title mb-5">Join </router-link>
                    <div class="mt-5"><img src="../../assets/images/club.svg" alt=""></div>
                    <p class="sub-title mt-3">
                        Language Club
                    </p>
                </div>
            </b-col>
        </b-row>
         <b-row align-h="center">
            <b-col class="text-center mb-5" md="6" cols="12">
                <div class="box box-blue">
                    <span @click="openInterprete" class="title mb-5">Create</span>
                    <div class="mt-5"> <img src="../../assets/images/interpreters.png" alt=""></div>
                    <p class="sub-title mt-3">
                         Interpreter Profile
                    </p>
                </div>

            </b-col>
            <b-col class="text-center mb-5" md="6" cols="12">
                <div class="box box-pink">
                    <router-link to="/languages/interpreters" class="title mb-5">Hire </router-link>
                    <div class="mt-5"><img src="../../assets/images/interpreter.png" alt=""></div>
                    <p class="sub-title mt-3">
                       Language Interpreter
                    </p>
                </div>
            </b-col>
        </b-row>
    </b-container>
    <Footer />
</div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import BodyLinks from "@/components/BodyLinks.vue";
import Footer from "@/components/Footer.vue";
import BlackHeaderCenter from "@/components/BlackHeaderCenter.vue";
import BlackHeaderMobile from "@/components/BlackHeaderMobile.vue";
import Activation from "@/components/Activation.vue";

export default {
    name: 'language',
    components: {
        Header,
        BodyLinks,
        BlackHeaderCenter,
        BlackHeaderMobile,
        Activation,
        Footer
    },
    data: function () {
        return {
            headerText: "EXPLORE LANGUAGES",
            subText: "Experience a plethora of languages around the world",
            fadedText: "Language"
        }
    },
    metaInfo() {
        return {
            title:`Culture Square | ${this.headerText}`,
            meta: [{
                    name: 'description',
                    content: this.subText
                },
                {
                    property: "og:title",
                    content: `Culture Square | ${this.headerText}`
                },
                {
                    property: "keywords",
                    content: 'Cultural studies, Offensive to other cultures, Cultural celebrations, Cultural Experience, Culture Around the World, Cultural differences, Cultural Diversity, Different cultures, Language clubs, Online Language Classes, Culture shock'
                },
                {
                    property: 'og:site_name',
                    content: 'Culture Square'
                },
                {
                    property: 'og:type',
                    content: 'website'
                },
                {
                    name: 'robots',
                    content: 'index,follow'
                }
            ]
        }
    },
    computed: {
        isLoggedIn: function () {
            return this.$store.getters.isLoggedIn;
        }
    },
    methods: {
        openTeach() {
            if (!this.isLoggedIn) {
                this.$router.push({
                    name: "sign-in",
                    query: {
                        redirect: "/languages/events/create",
                    },
                });
            } else {
                this.$router.push({
                    name: "create-language-event",
                });
            }
        },
        openCreate() {
            if (!this.isLoggedIn) {
                this.$router.push({
                    name: "sign-in",
                    query: {
                        redirect: "/languages/clubs/create",
                    },
                });
            } else {
                this.$router.push({
                    name: "create-language-club",
                });
            }
        },
        openInterprete() {
            if (!this.isLoggedIn) {
                this.$router.push({
                    name: "sign-in",
                    query: {
                        redirect: "/languages/interpreters/create",
                    },
                });
            } else {
                this.$router.push({
                    name: "create-interpreter-profile",
                });
            }
        }
    }

}
</script>

<style scoped>
.box {
    box-shadow: 0px 16px 26px rgba(86, 92, 99, 0.12);
    border-radius: 32px;
    padding: 40px 16px;
    height: 100%;
    margin: 0 5%;
}

.box span {
    cursor: pointer
}

.box .title {
    background: #343859;
    box-shadow: 0px 11px 9px rgba(51, 51, 51, 0.25);
    border-radius: 24px;
    padding: 12px 32px;
    text-transform: uppercase;
    color: #fff;
    font-size: 1.2rem;
}

.box .sub-title {
    font-size: 1.2rem;
}

.box-green {
    background: rgba(215, 252, 197, 0.24);
}

.box-peach {
    background: #FEF9F1
}

.box-lilac {
    background: #FEF1FE;
}

.box-pink {
    background: #FEF1F1;
}

.box-blue{
    background:#e9effb
}
.box-skye-blue{
    background:#F0FDFE
}
</style>
